import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import {
  Router,
  ActivatedRoute,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Event,
  NavigationStart,
  NavigationEnd,
  NavigationError,
} from '@angular/router';
import { CoreService } from '../../core.service';
import { BaseManagement } from 'src/app/core/services/base-management';
import { MultiLanguageService } from 'src/app/core/services/multi-language.service';
import { NotificationService } from 'src/app/shared/notifications/notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { DialogYesNoComponent } from 'src/app/core/components/dialog-yes-no/dialog-yes-no.component';
import { TranslateService } from '@ngx-translate/core';
import { __param } from 'tslib';
import { SettingService } from '../../services/setting.service';
import { GlobalsService } from '../../services/globals.service';
import { ShoppingCartService } from 'src/app/pages/shopping-cart/services/shopping-cart.service';
import { MatDialog } from '@angular/material/dialog';
import { ProfileService } from 'src/app/pages/account/services/profile.service';
import { ProfileSelectionModalComponent } from '../profile-selection-modal/profile-selection-modal.component';
declare function toggleNotifications(): any;

@Component({
  selector: 'prgov-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseManagement implements OnInit {
  @Input() inSideNav = false;
  @Output() openSidenav = new EventEmitter();
  @Output() closeSidenav = new EventEmitter();
  badgeCartList: any[] = [];
  signedIn: boolean;
  currentRoute: string;
  toggleHomeMessage = false;
  imageURL: string;
  isTopBarVisible = false;
  isLoading: boolean = false;

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private coreService: CoreService,
    public multiLanguageService: MultiLanguageService,
    public notificationService: NotificationService,
    public authService: AuthService,
    public translate: TranslateService,
    public settingService: SettingService,
    public globalsService: GlobalsService,
    public shoppingCartService: ShoppingCartService,
    public dialog: MatDialog,
    private profileService: ProfileService
  ) {
    super();

    // router.events.filter(event => event instanceof NavigationEnd)
    //       .subscribe(event =>
    //        {
    //           this.currentRoute = event.url;
    //           console.log(event);
    //        });
  }

  ngOnInit() {
    // this.goTo();
    this.refreshLanguage();

    let isLoggedIn = this.authService.isLoggedIn();
    // console.log(isLoggedIn);
    if (isLoggedIn) {
      this.shoppingCartService.getList()
        .then(
          (data: any) => { this.badgeCartList = data.Data }
        );
    }

    this.notificationService.getCount();

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        // Close sidenav if open
        this.closeSidenav.emit();
      }
    });

    this.settingService.getLogoHeader().then((filename) => {
      this.imageURL = this.globalsService.sa + '/' + filename;
      // console.log(this.imageURL);
    });
    // console.log('!this.authService .isLoggedIn(): ' + !this.authService .isLoggedIn())
    // console.log('this.currentRoute: ' + this.currentRoute)
  }

  hasRoute(route: string) {
    return this.router.url.includes(route);
  }

  logOut(): void {
    // Logout user in service then redirecto to
    // if(this.authService.hasPolicy("CanAttendProcesses")){
    this.notificationService.messageCount = 0;
    this.notificationService.list = [];
    this.authService.logout();
    // this.router.navigate(['/login-admin']);
    // }else{
    // this.authService.logout();
    // this.router.navigate(['/login']);
    // }
  }

  goTo() {
    this.router.events.subscribe((val: any) => {
      if (val.url) {
        console.log('val.url: ' + val.url);

        if (!this.authService.isLoggedIn() && val.url === '/login-admin') {
          this.toggleHomeMessage = true;
        } else {
          this.toggleHomeMessage = false;
        }
      }
    });
  }

  goHome(): void {
    this.router.navigate(['/']);
  }

  goBack(): void {
    window.history.back();
  }

  openNotifications() {
    this.closeSidenav.emit();
    this.notificationService.notificationRefresh.next();
    this.notificationService.showNotifications = true;
  }

  tryLogout() {
    this.translate
      .get(['message.logoutConfirmText', 'message.yes', 'message.no'])
      .subscribe((translations) => {
        const dialogRef = this.dialog.open(DialogYesNoComponent, {
          width: '300px',
          maxWidth: '90vw',
          panelClass: ['custom-dialog', 'logout-dialog'],
          data: {
            msg: translations['message.logoutConfirmText'],
            yesText: translations['message.yes'],
            noText: translations['message.no'],
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result === 1) {
            this.logOut();
          }
        });
      });
  }

  /**
   * Abre el modal para seleccionar un perfil médico
   */
  openProfileSelectionModal(): void {
    this.authService.openProfileSelectionModal(localStorage.getItem('selectedProfile') ? false : true);
  }
}
